
































import {Emit} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component, Vue} from '@/shared/component';

import {Proprietaire} from '@/models';

import CrudProprietaireShow from '@/components/Crud/Proprietaire/Show.vue';

@Component({
	components: {
		CrudProprietaireShow,
	}
})
export default class CrudProprietaireShowDialog extends Vue {
	@InOut({ type: Proprietaire  , isVModel: true }) private value!: Proprietaire;
	
	@Emit()
	public onClose() {
		this.value = null;
	}
}
